import { useTemplateStore } from '@/stores/template';
import type { PreloadHandler } from '@/types/router';
import type { RouteLocationNormalized } from 'unplugin-vue-router';

export const preloadContractTemplates: PreloadHandler = async (
  to: RouteLocationNormalized,
) => {
  const { getTemplatesForContract } = useTemplateStore();

  if (!(to.params as { contractId: string }).contractId) {
    console.error('Error in data preloader: missing required route param');

    return;
  }

  await getTemplatesForContract(
    (to.params as { contractId: string }).contractId,
  );
};
